export const shouldClosePopover = (event) => {
  const { id, localName, className, parentElement } = event.target;

  return (
    !id.includes('question') &&
    !id.includes('action') &&
    localName !== 'input' &&
    localName !== 'textarea' &&
    typeof className === 'string' &&
    !className?.includes('ant-') &&
    !parentElement?.className.includes('ant-') &&
    !parentElement?.className.includes('commentBoxAvatar')
  );
};
